export enum WebRTCServerSource {
    Twilio = 'twilio',
    Internal = 'internal'
}
